module.exports = __webpack_public_path__ + "static/media/newsletter-asset.fe3aef2a.png";